var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHousekeepingBedDirty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1034_9151",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#62BA60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1034_9151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0012 14.3757H20.5505C20.5505 14.6949 20.5505 15.0028 20.5505 15.3106C20.5505 15.8022 20.5458 16.2945 20.5519 16.7861C20.5552 17.0806 20.4289 17.2067 20.1264 17.206C14.5574 17.202 8.98764 17.2026 3.41858 17.2046C3.18603 17.2046 3.00658 17.1456 3.00389 16.8827C2.99717 16.0571 3.0012 15.2321 3.0012 14.375V14.3757Z",
    fill: "url(#paint0_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.473 11.2106H15.9735C15.9675 11.0966 15.9614 10.9892 15.9554 10.8826C15.9298 10.4104 15.6112 10.0986 15.1327 10.0939C14.5386 10.0878 13.9451 10.0912 13.351 10.0925C12.742 10.0939 12.4571 10.3735 12.4315 10.9879C12.4288 11.053 12.4201 11.118 12.412 11.2025H11.1344C11.1276 11.0851 11.1223 10.9664 11.1135 10.8484C11.0839 10.4158 10.7647 10.1012 10.3265 10.0945C9.72159 10.0858 9.11602 10.0912 8.51113 10.0925C7.90355 10.0939 7.61656 10.3756 7.59169 10.9886C7.589 11.0536 7.58026 11.118 7.5722 11.2032H6.06803C6.06803 10.5479 6.00619 9.89602 6.08483 9.26087C6.16884 8.57945 6.78718 8.08448 7.47609 8.00333C7.60916 7.98791 7.74359 7.97449 7.87801 7.97449C10.4777 7.97315 13.0774 7.97114 15.6771 7.97449C16.6154 7.97583 17.3325 8.43123 17.4542 9.23405C17.5516 9.87455 17.4736 10.5412 17.4736 11.2106H17.473Z",
    fill: "url(#paint1_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.21289 13.7375C3.78418 13.2573 4.32724 12.8603 4.79637 12.3901C5.26147 11.9233 5.7763 11.8066 6.41614 11.8106C10.1793 11.8361 13.9424 11.8254 17.7055 11.818C17.9575 11.818 18.1477 11.8864 18.3366 12.0508C18.8931 12.5357 19.4651 13.0025 20.0303 13.4773C20.113 13.5471 20.1909 13.6222 20.3173 13.7375H3.21289Z",
    fill: "url(#paint2_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7524 8.14114C19.249 8.14114 18.7449 8.14383 18.2415 8.14047C17.8261 8.13779 17.7085 7.97146 17.8658 7.59856C18.1555 6.91043 18.4579 6.22834 18.7442 5.53887C18.8282 5.33699 18.9438 5.24242 19.1717 5.25047C19.5743 5.26523 19.9775 5.26322 20.3801 5.25047C20.5885 5.24444 20.7128 5.31955 20.7928 5.51137C21.0905 6.22029 21.4011 6.92317 21.6968 7.63276C21.8299 7.95201 21.7082 8.1331 21.3648 8.13846C20.8278 8.14651 20.2901 8.14047 19.7531 8.14047L19.7524 8.14114Z",
    fill: "url(#paint3_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0506 12.6767C19.6574 12.4345 19.4221 12.1964 19.4517 11.7075C19.5028 10.8524 19.4658 9.99188 19.4658 9.1334V8.75781H20.0506V12.6767Z",
    fill: "url(#paint4_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77015 17.8145H5.8409C5.8409 18.0619 5.87451 18.3081 5.82612 18.5368C5.80327 18.6454 5.62785 18.7923 5.51426 18.799C5.03639 18.8285 4.55449 18.8279 4.07663 18.799C3.96976 18.7923 3.80644 18.6414 3.78426 18.5334C3.73856 18.3121 3.77082 18.074 3.77082 17.8145H3.77015Z",
    fill: "url(#paint5_linear_1034_9151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6999 17.8203H19.7774C19.7774 18.0671 19.805 18.3126 19.7646 18.546C19.7472 18.6466 19.5912 18.7928 19.4918 18.7982C19.0025 18.8243 18.5105 18.8116 18.0199 18.8096C17.7893 18.8089 17.7127 18.654 17.7026 18.4595C17.6919 18.2603 17.7006 18.0604 17.7006 17.821L17.6999 17.8203Z",
    fill: "url(#paint6_linear_1034_9151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_9151",
    x1: 11.776,
    y1: 14.375,
    x2: 11.776,
    y2: 17.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1034_9151",
    x1: 11.774,
    y1: 7.97266,
    x2: 11.774,
    y2: 11.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1034_9151",
    x1: 11.7651,
    y1: 11.8105,
    x2: 11.7651,
    y2: 13.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1034_9151",
    x1: 19.7742,
    y1: 5.25,
    x2: 19.7742,
    y2: 8.14265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1034_9151",
    x1: 19.7499,
    y1: 8.75781,
    x2: 19.7499,
    y2: 12.6767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1034_9151",
    x1: 4.80601,
    y1: 17.8145,
    x2: 4.80601,
    y2: 18.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1034_9151",
    x1: 18.7419,
    y1: 17.8203,
    x2: 18.7419,
    y2: 18.8144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeepingBedDirty);
export default __webpack_public_path__ + "static/media/housekeeping_bed_dirty.4a141b5dcc6521755f8d9fe9423ccc7f.svg";
export { ForwardRef as ReactComponent };